export const genericNullableValue = <T>(value: T | null | undefined = undefined): T | null => value ?? null;

export const genericValue = <T>(value: T): T => value;
